function secondsToTimeStamp(seconds) {
    const secondsPerHour = 60 * 60;
    const totalHours = Math.floor(seconds / secondsPerHour);

    let timeString = new Date(1000 * seconds).toISOString().slice(11, -1);
    return [totalHours.toString().padStart(2, '0'), ...timeString.split(':').slice(1)].join(':');
}

const escapeHelper = document.createElement('div');
function escapeString(text) {
    escapeHelper.textContent = text;
    return escapeHelper.innerHTML;
}

/**
 * Generates a virtual VTT file for the given array of cues.
 * @param {Array<VTTCue>} cues
 */
export function makeVTT(cues) {
    
    const text = cues.reduce((vttString, { startTime, endTime, text }) => vttString + `

${secondsToTimeStamp(startTime)} --> ${secondsToTimeStamp(endTime)}
${escapeString(text)}`, `WEBVTT`);

    return new Blob([text], { type: "text/plain" });
};
